import React, { FunctionComponent } from 'react';
import { Flex, Box } from '@rebass/emotion';
import { FormattedMessage } from 'react-intl';

import Link from '@app/components/Link';

import { H1, H3 } from '../../components/typography';
import rootMessages from './AccountLayout.messages';

interface MenuItemProps {
  name: string;
  image: string;
  to: string;
}

const MenuItem: FunctionComponent<MenuItemProps> = ({ name, image, to }) => (
  <Box
    width={[1, 1, 1 / 3]}
    py={30}
    px={[0, 0, 30, 45]}
    textAlign="center"
    lineHeight={1.5}
  >
    <Link to={`/:language/account/${to}/`}>
      <img src={image} alt="" style={{ marginBottom: '10px' }} />
    </Link>
    <H3>
      <FormattedMessage {...rootMessages[name]} />
    </H3>
    <p>
      <FormattedMessage {...rootMessages[`${name}Description`]} />
    </p>
    <Link to={`/:language/account/${to}/`}>
      <FormattedMessage {...rootMessages[name]} /> →{' '}
    </Link>
  </Box>
);

const Account: FunctionComponent = () => (
  <>
    <H1 as="h2">
      <FormattedMessage {...rootMessages.title} />
    </H1>
    <p>
      <FormattedMessage {...rootMessages.description} />
    </p>

    <Flex px={[0, 0, 0, 0, 80]} alignItems="flex-start" flexWrap="wrap">
      <MenuItem
        name="accountSettings"
        to="account-settings"
        image="https://www.native-instruments.com/typo3temp/pics/img-ce-05_icon_myaccount_2x_01-0f10aa3b989c5d318133a47f0c820b13-d.jpg"
      />
      <MenuItem
        name="orderHistory"
        to="orders"
        image="https://www.native-instruments.com/typo3temp/pics/img-ce-03_icon_orderhistory_2x-8bb5929382b14986776acebd72cbb382-d.jpg"
      />
      <MenuItem
        name="productsSerialsAndDownloads"
        to="#"
        image="https://www.native-instruments.com/typo3temp/pics/img-ce-02_icon_myproducts_2x-7ab06c8484b23656926494ab053f7dfc-d.jpg"
      />
      <MenuItem
        name="updatesAndDrivers"
        to="updates-and-drivers"
        image="https://www.native-instruments.com/typo3temp/pics/img-ce-04_icon_productupdates_2x-9a4f263dc979c660c11f76ea477d94d6-d.jpg"
      />
      <MenuItem
        name="coupons"
        to="vouchers"
        image="https://www.native-instruments.com/typo3temp/pics/img-ce-06_icon_vouchers_2x-6f98093f03f54146768ad53baa72a4c2-d.jpg"
      />
      <MenuItem
        name="licenseTransfer"
        to="license-transfer"
        image="https://www.native-instruments.com/typo3temp/pics/img-ce-02_icon_intransfer_2x-d701bab55df13203e5f981d9cba1b9dd-d.jpg"
      />
    </Flex>
  </>
);

export default Account;
